import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideBlockList,
  GuideContrast,
} from "../GuideBlocks.js";

const ReflectionVsRuminationSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="reflection-vs-rumination"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Looking back is not always unhealthy. The difference lies in <em>how</em> you look back.
    </GuideLead>
    <GuideCompare
      leftTitle="Reflection"
      rightTitle="Rumination"
      left={
        <>
          <p>Reflection is intentional learning.</p>
          <p>You revisit an experience to understand it, learn from it, and improve your future decisions.</p>
          <GuideBlockList
            items={[
              "What happened?",
              "What did I learn?",
              "What could I do differently next time?",
            ]}
          />
        </>
      }
      right={
        <>
          <p>Rumination is repetitive thinking without progress.</p>
          <p>It keeps replaying the same situation again and again.</p>
          <GuideBlockList
            items={[
              "Why did this happen?",
              "Why me?",
              "What if I had done this?",
              "Why can't I stop thinking about it?",
            ]}
          />
        </>
      }
    />
    <GuideContrast
      items={[
        { title: "Reflection moves you forward.", text: "It creates growth." },
        { title: "Rumination keeps you stuck.", text: "It increases stress without moving toward a solution." },
      ]}
    />
    <GuideCallout variant="amber">
      Whenever you notice repetitive thinking, redirect the question from "Why?" to "What can I
      learn?" That small change can close the loop instead of restarting it.
    </GuideCallout>
  </GuidePanel>
);

export default ReflectionVsRuminationSection;
